import axios from "axios"
import { useEffect, useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { presses } from "../../utilities/Lists"
import { v4 as uuidv4 } from "uuid"
import { MainWrap } from "../../utilities/Shared"

const Savejob = () => {
  const { job } = useParams()
  const nav = useNavigate()

  const [customerinfo, setCustomerinfo] = useState(null)
  const [imposition, setImposition] = useState([])

  const config = {
    headers: { "Content-Type": "application/json" }
  }

  /* ================= HELPERS (MUST BE FIRST) ================= */

  const isDigital = id => [7, 8, 9, 10].includes(parseInt(id))

  const changetext = id => {
    if (id == 9) return "Colormax"
    if ([7, 8, 10].includes(parseInt(id))) return "Digital"
    return "Press"
  }

  const getpress = id => presses.find(p => p.id == id)?.name || ""

  const validDate = (val, addDay = false) => {
    if (!val || val === "0000-00-00") return null
    const d = new Date(val)
    if (isNaN(d)) return null
    if (addDay) d.setDate(d.getDate() + 1)
    return d
  }

  /* ----- EXACT OLD MATH ----- */

  const multitopress = (
    mr,
    additionalmr,
    needed,
    mroverride,
    numup,
    versions,
    forms
  ) => {
    const m =
      mroverride > 0
        ? parseInt(mroverride) / forms
        : parseInt(mr) / forms

    const to =
      ((parseInt(needed) +
        parseInt(mr) +
        parseInt(additionalmr)) *
        parseInt(versions)) /
      forms

    return {
      mr: m,
      to,
      off: to - m
    }
  }

  const singletopress = (mr, additionalmr, needed, mroverride) => {
    const m = mroverride > 0 ? parseInt(mroverride) : parseInt(mr)
    const to = parseInt(needed) + m + parseInt(additionalmr)

    return {
      mr: m,
      to,
      off: to - m
    }
  }

  const buildForm = (item, n, sett) => {
    const digital = isDigital(item.press)

    const topress =
      sett === "multi"
        ? multitopress(
            item.mr,
            item.additionalmr,
            item.needed,
            item.mroverride,
            item.numup,
            item.versions,
            item.numforms
          )
        : singletopress(
            item.mr,
            item.additionalmr,
            item.needed,
            item.mroverride
          )

    console.log(`📄 Form ${item.component}`, topress)

    return {
      item: item.id,
      totalpages: item.pages,
      pages: item.pages / item.numforms,
      numup: item.numup,
      versions: item.versions,
      pressid: item.press,
      pressname: getpress(item.press),
      width: item.sheetw,
      length: item.sheetl,
      method: item.method,
      numforms: item.numforms,
      name: sett === "multi" ? `${n}) ${item.component}` : item.component,
      paper: item.paper,
      fink: item.fink,
      bink: item.bink,
      faq: item.faq,
      baq: item.baq,
      totalinkused: item.totalinkused || "",
      processtext: changetext(item.press),
      formid: uuidv4(),
      originalform: item.component,
      originalformid: item.id,
      digital,
      stockid: item.paperid,
      partofid: sett === "multi" ? `${item.id}${n}` : 0,
      sett,
      topress
    }
  }

  /* ================= LOAD DATA ================= */

  useEffect(() => {
    if (!job) return

    const loadAll = async () => {
      try {
        console.log("🔵 Loading job data:", job)

        const payload = { job }

        const [impRes, custRes] = await Promise.all([
          axios.post(
            "https://highgroundsoftware.com/dash/dashboard/php/getjobbyjobnumber.php",
            payload,
            config
          ),
          axios.post(
            "https://highgroundsoftware.com/dash/dashboard/php/getjobcustomerbyjob.php",
            payload,
            config
          )
        ])

        console.log("✅ Imposition loaded:", impRes.data)
        console.log("✅ Customer loaded:", custRes.data)

        setImposition(impRes.data || [])

        const c = custRes.data?.[0]
        if (c) {
          setCustomerinfo({
            ...c,
            dateentered: validDate(c.dateentered),
            duedate: validDate(c.duedate, true)
          })
        }
      } catch (err) {
        console.error("❌ Load error", err)
      }
    }

    loadAll()
  }, [job])

  /* ================= BUILD FORMS ================= */

  const forms = useMemo(() => {
    if (!imposition.length) return []

    console.log("🟡 Building forms…")

    const made = []

    imposition.forEach(item => {
      const digital = isDigital(item.press)

      if (parseInt(item.numforms) > 1 && !digital) {
        for (let n = 1; n <= item.numforms; n++) {
          made.push(buildForm(item, n, "multi"))
        }
      } else {
        made.push(buildForm(item, 1, "single"))
      }
    })

    console.log("✅ Forms built:", made)
    return made
  }, [imposition])

  /* ================= SAVE ================= */

  useEffect(() => {
    if (!customerinfo || !forms.length) return

    const save = async () => {
      const payload = {
        ...customerinfo,
        forms,
        imposition,
        allocated: "",
        pullcut: ""
      }

      console.log("🟢 Saving job payload:", payload)

      try {
        await axios.post(
          "https://highgroundapi.herokuapp.com/jobs/add",
          payload
        )
        nav(`/jobticket/good/${job}`, { replace: true })
      } catch (err) {
        console.error("❌ Save failed", err)
      }
    }

    save()
  }, [customerinfo, forms, imposition, job, nav])

  /* ================= UI ================= */

  return (
    <MainWrap>
      <span style={{ fontSize: "2rem", color: "green" }}>
        Configuring Job. Please wait one moment…
      </span>
    </MainWrap>
  )
}

export default Savejob
